// Thư viện
import axios from 'axios'
import ls from 'local-storage'
import router from '@/router'
import store from '@/store'

// Cấu hình chung
axios.defaults.baseURL = process.env.API_URI
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post['Accept'] = 'application/json'

// Cấu hình request trước khi gửi di
axios.interceptors.request.use(config => {
  const token = ls.get('authen', '')
  if (token) {
    config.headers.Authorization = `Bearer ${token.access_token}`
  } else {
    config.headers.Authorization = 'Bearer'
  }
  return config
}, error => {
  // Do something with request error
  return Promise.reject(error)
})

// Cấu hình khi nhận dc response
axios.interceptors.response.use(function (response) {
  return response.data
}, function (error) {
  let status = error.response.status
  if (status === 501) {
    alert('Liên hệ admin để được phân phụ trách tên miền')
  }
  if (status === 401) {
    const token = ls.get('authen', '')
    if (token) {
      ls.remove('authen')
    }
    store.dispatch('account/removeAccountInfo', null, { root: true })
    router.push({name: 'account-login'})
  }
  return error.response.data
})



// WEBPACK FOOTER //
// ./src/api/config.js